import {
  BsCameraReels
} from 'react-icons/bs';

import {
  FaEnvelope,
  FaGavel,
  FaGift,
  FaMoneyBillAlt,
  FaPaintRoller,
  FaRegBuilding,
  FaServer,
  FaShippingFast,
  FaStoreAlt,
  FaTicketAlt
} from 'react-icons/fa';

import { GrIntegration } from "react-icons/gr";

import { LuPackageOpen } from "react-icons/lu";

import { MdConstruction } from "react-icons/md";

import {
  VscAccount,
  VscArchive,
  VscFile,
  VscFolder,
  VscPieChart,
  VscSettingsGear
} from 'react-icons/vsc';

export const groupedMenuItemsAdmin = [
  {
    title: 'Dashboard',
    items: [
      { title: 'Metrics', path: '/', icon: <VscPieChart /> },
    ],
  },
  {
    title: 'Users',
    items: [
      { title: 'Users', path: '/accounts', icon: <VscAccount /> },
      { title: 'Companies', path: '/companies', icon: <FaRegBuilding /> },
    ],
  },
  {
    title: 'Shop',
    items: [
      { title: 'Orders', path: '/orders', icon: <FaStoreAlt /> },
      // { title: 'Fulfillments', path: '/fulfillments', icon: <LuPackageOpen /> },
      { title: 'Categories', path: '/categories', icon: <VscArchive /> },
      { title: 'Products', path: '/products', icon: <VscFolder /> },
      { title: 'Inventories', path: '/inventories', icon: <VscFile /> },
      { title: 'Shipping', path: '/shipping', icon: <FaShippingFast /> },
    ],
  },
  {
    title: 'Marketing',
    items: [
      { title: 'Giveaways', path: '/giveaways', icon: <FaGift /> },
    ],
  },
  {
    title: 'System',
    items: [
      { title: 'Content Management', path: '/content-management', icon: <MdConstruction /> },
      { title: 'Configurations', path: '/configurations', icon: <VscSettingsGear /> },
      { title: 'Integrations', path: '/integrations', icon: <GrIntegration /> },
    ],
  },
];

export const groupedMenuItemsContributor = [
  {
    title: 'General',
    items: [
      {
        title: 'Home',
        path: '/',
        icon: <VscAccount />,
      },
      {
        title: 'Company',
        path: '/company',
        icon: <FaRegBuilding />,
      },
      {
        title: 'Giveaways',
        path: '/giveaways',
        icon: <FaGift />,
      },
    ],
  },
];